import { Component, Input } from '@angular/core';

export interface AbstractButtonConfig<Choice>
{
  labelKey: string;
  choice: Choice;
  replacements?: Record<string, string>;
}

export enum Choice
{
  OK,
  RETRY,
  IGNORE,
  CANCEL,
  CONTINUE,
}

type ButtonConfig = AbstractButtonConfig<Choice>;

export class Button {
  public static Choice: any = Choice;

  public static readonly OK: ButtonConfig = {
    labelKey: 'i18n.button.close',
    choice: Choice.OK,
  };

  public static readonly RETRY: ButtonConfig = {
    labelKey: 'i18n.button.retry',
    choice: Choice.RETRY,
  };

  public static readonly IGNORE: ButtonConfig = {
    labelKey: 'i18n.button.ignore',
    choice: Choice.IGNORE,
  };

  public static readonly CANCEL: ButtonConfig = {
    labelKey: 'i18n.button.cancel',
    choice: Choice.CANCEL,
  };

  public static readonly CONTINUE: ButtonConfig = {
    labelKey: 'i18n.button.continue',
    choice: Choice.CONTINUE,
  };

  public static readonly IGNORE_AND_CONTINUE: ButtonConfig = {
    labelKey: 'i18n.button.ignoreAndContinue',
    choice: Choice.IGNORE,
  };

  public static readonly CANCEL_AND_FIX: ButtonConfig = {
    labelKey: 'i18n.button.cancelAndFix',
    choice: Choice.CANCEL,
  };

  public static readonly WITHOUT_SMART_SORTED: ButtonConfig = {
    labelKey: 'i18n.button.withoutSmartSorted',
    choice: Choice.CONTINUE,
  };

  public static readonly WITH_SMART_SORTED: ButtonConfig = {
    labelKey: 'i18n.button.withSmartSorted',
    choice: Choice.OK,
  };

  public static readonly CONTINUE_DESIGNING: ButtonConfig = {
    labelKey: 'i18n.button.continueDesigning',
    choice: Choice.CANCEL,
  };

  public static readonly RETURN_TO_HOME_PAGE: ButtonConfig = {
    labelKey: 'i18n.button.returnToHomePage',
    choice: Choice.CONTINUE,
  };

  public static readonly DELETE_IMAGE: ButtonConfig = {
    labelKey: 'i18n.button.deleteImage',
    choice: Choice.CONTINUE,
  };

  public static readonly WITHOUT_PHOTO: ButtonConfig = {
    labelKey: 'i18n.button.withoutPhoto',
    choice: Choice.CONTINUE,
  };

  public static readonly WITHOUT_THIS_PHOTO: ButtonConfig = {
    labelKey: 'i18n.button.withoutThisPhoto',
    choice: Choice.CONTINUE,
  };

  public static readonly CHOOSE_NEW_IMAGE: ButtonConfig = {
    labelKey: 'i18n.button.chooseNewImage',
    choice: Choice.RETRY,
  };

  public static readonly CHOOSE_OTHER_PHOTO: ButtonConfig = {
    labelKey: 'i18n.button.chooseOtherPhoto',
    choice: Choice.CONTINUE,
  };

  public static readonly RETRY_PHOTO: ButtonConfig = {
    labelKey: 'i18n.button.retryPhoto',
    choice: Choice.RETRY,
  };

  public static readonly RELOAD: ButtonConfig = {
    labelKey: 'i18n.button.reload',
    choice: Choice.RETRY,
  };

  public static readonly RESTART_DESIGNER: ButtonConfig = {
    labelKey: 'i18n.button.restartDesigner',
    choice: Choice.RETRY,
  };

  public static readonly PUZZLEYOU_SHOP: ButtonConfig = {
    labelKey: 'i18n.button.puzzleYouShop',
    choice: Choice.CONTINUE,
  };

  public static readonly SHOP: ButtonConfig = {
    labelKey: 'i18n.button.shop',
    choice: Choice.CONTINUE,
  };

  public static readonly RESTART: ButtonConfig = {
    labelKey: 'i18n.button.restart',
    choice: Choice.RETRY,
  };

  public static readonly CHANGE_PRODUCT: ButtonConfig = {
    labelKey: 'i18n.button.changeProduct',
    choice: Choice.CONTINUE,
  };

  public static readonly KEEP_PRODUCT: ButtonConfig = {
    labelKey: 'i18n.button.keepProduct',
    choice: Choice.CANCEL,
  };
}

export interface ButtonsAssignment {
  primary?: AbstractButtonConfig<any>;
  secondary?: AbstractButtonConfig<any>;
}

@Component({
    selector: 'dialog-buttons',
    templateUrl: './dialog-buttons.component.html',
    styleUrls: ['./dialog.scss'],
    standalone: false
})
export class DialogButtonsComponent
{
  @Input() public buttons: ButtonsAssignment;
  @Input() public stacked: boolean = false;
}
